import React from 'react';
import {
  Block,
} from '@uncinc/react-drupal-core';

import {
  BLOCK_NEWSLETTER_BLOCK_ID,
} from '../../config/constants';

import './style.scss';

const NewsletterSignup = (props) => {
  return (
    <div className="NewsletterSignup">
      <Block id={BLOCK_NEWSLETTER_BLOCK_ID} />
    </div>
  );
};

export default NewsletterSignup;
